<template>
  <div class="wrap-page">
    <div class="line">
      <div class="page-access">
        <div class="wrap-page-access">
          <div class="box-page-access">
                <div><img src="@/assets/images/access.png"></div>
                <div class="title-access">404</div>
                <div class="desc-access">Rất tiếc. Chúng tôi không thể tìm thấy trang này...</div>
              <div class="link-access"><a href="javascript:void(0)" @click="clickToIndex">Trở về trang chủ</a></div>
            </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'NotFound',
  data () {
    return {
      loading: true
    }
  },
  methods: {
    clickToIndex () {
      this.$router.push({ path: '/' })
    }
  }
}
</script>
